module.exports = __webpack_public_path__ + "static/z16-2-puck-lokalizacja-e41556db73c518941eac2c739cc528df.png";